import '@angular/compiler';
import { ComponentReportComponent } from './component.report/component.report.component';
import { PageNewComponent } from './page.new/page.new.component';
import { ComponentNewComponent } from './component.new/component.new.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PageSettingComponent } from './page.setting/page.setting.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { ComponentChatComponent } from './component.chat/component.chat.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageReportComponent } from './page.report/page.report.component';
import { PageMainComponent } from './page.main/page.main.component';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { ComponentChatSidebarComponent } from './component.chat.sidebar/component.chat.sidebar.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        AppComponent,
        ComponentReportComponent,
        PageNewComponent,
        ComponentNewComponent,
        PageLoginComponent,
        PortalSeasonTabComponent,
        PageSettingComponent,
        PortalSeasonLoadingComponent,
        PortalSeasonLoadingSeasonComponent,
        ComponentChatComponent,
        PortalSeasonAlertComponent,
        PageSignupComponent,
        PortalSeasonUiDropdownComponent,
        PortalSeasonLoadingHexaComponent,
        LayoutEmptyComponent,
        PageReportComponent,
        PageMainComponent,
        ComponentNavComponent,
        PortalSeasonViewerTreeComponent,
        ComponentChatSidebarComponent,
        PortalSeasonStatusbarComponent,
        LayoutNavbarComponent,
        PortalSeasonPagenationComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }